module.exports = __webpack_public_path__ + "img/hicon5.3b866fc4.png";